import React from 'react';
import { painPoints } from '../data/content';
export function WhySection() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-166" data-mp="13v04hm1412si">
      <div className="mx-auto max-w-2xl" data-id="element-167" data-mp="13vjfeisceqx1">
        <h2 className="text-center text-[1.2rem] font-black uppercase leading-tight text-navy sm:text-[1.8rem]" data-id="element-168" data-mp="18umjo10i0t3y">
          DOES THIS SOUND FAMILIAR?
        </h2>
        <p className="mt-1 text-center text-[0.8rem] leading-[1.4] sm:text-[0.95rem]" data-id="element-169" data-mp="1dn5y1070fs9t">
          You know the equipment—but when an oven won't heat, a fryer won't ignite, a refrigerator
          won't cool, or a dishwasher stops mid-cycle, one symptom can point to several possible
          causes.
        </p>
        <div className="mt-2 divide-y divide-navy/10 border-y border-navy/10" data-id="element-170" data-mp="1rj1c8sqgsf6v">
          {painPoints.map(p => <div key={p.title} className="border-l-4 border-electric py-2 pl-2.5" data-id="element-171" data-mp="3tch0xk2zrjz7">
              <h3 className="text-[0.76rem] font-extrabold uppercase leading-tight text-navy sm:text-[0.95rem]" data-id="element-172" data-mp="3tek2909lgzj8">
                {p.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] sm:text-[0.9rem]" data-id="element-173" data-mp="2igex188vlwji">{p.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}